import { jsx } from "panel";
import { ManualCodeModalEl } from "common/widgets/two-factor-set-up-methods/totp/qr-code/manual-code-modal";
export function template() {
  return /* @__PURE__ */ jsx("div", {
    sel: ".qr-code-el-container"
  }, /* @__PURE__ */ jsx("h1", {
    sel: ".auth-form-title"
  }, "Set Up Authentication App"), /* @__PURE__ */ jsx("div", {
    sel: ".qr-form-subtitle"
  }, "Scan the image below with your two-factor authentication app.", ` `, /* @__PURE__ */ jsx("a", {
    sel: ".qr-learn-more-link",
    attrs: {
      href: `https://docs.mixpanel.com/docs/admin/two-factor-authentication`,
      target: `_blank`
    }
  }, "Learn more")), /* @__PURE__ */ jsx("div", {
    sel: ".canvas-container"
  }, /* @__PURE__ */ jsx("canvas", {
    class: { [this.helpers.getQrCodeCanvasClassName()]: true }
  })), /* @__PURE__ */ jsx("a", {
    sel: ".manual-code-link",
    on: { click: this.helpers.showSecretCodeModal }
  }, "Can't scan QR code?"), this.state.showSecretModal && /* @__PURE__ */ jsx(ManualCodeModalEl, {
    attrs: { secret: this.state.secret },
    on: { close: this.helpers.closeSecretCodeModal }
  }));
}
